import { RunnerGameOver } from './RunnerGameOver.tsx';
import { RunnerHud } from './RunnerHud.tsx';
import { RunnerPause } from './RunnerPause.tsx';

export function RunnerTvOverlays() {
  return (
    <>
      <RunnerHud />
      <RunnerPause />
      <RunnerGameOver />
    </>
  );
}
